import React from 'react';
import formatTime from 'mn-utils/formatTime';
import * as links from '../../../../../../constants/links';
import {apiAdminPayoutVertoGet} from '../../../../../../api/admin/payout/verto';
import toEllipsisMiddle from '../../../../../../utils/toEllipsisMiddle';
import withState from '../../../../../../utils/withState';
import Tooltip from '../../../../../dumb/Tooltip/A';
import LayoutB from '../../../../../dumb/Layout/B';
import CaptionA from '../../../../../dumb/Caption/A';
import HeaderA from '../../../../../dumb/Header/A';
import ButtonBack from '../../../../../dumb/Button/Back';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading';
import Field from '../../../../../dumb/Field/A';
import {Link} from '../../../../../../router';
import {LINK_ADMIN_PAYOUT} from "../../../../../../constants/links";

module.exports = withState((setState, self, onMount) => {
  onMount(() => {
    const {id} = self.props.params;
    apiAdminPayoutVertoGet({payout_id: id}).then((data) => {
      setState({
        accountId: data.account_id,
        groupId: data.group_id,
        merchantName: data.merchant_name,
        merchantEmail: data.merchant_email,
        bankId: data.bank_id,
        fiatCode: data.fiat_code,
        amount: data.amount,
        description: data.description,
        createdAt: data.created_at,
        status: data.status,
        tx: data.tx,
      });
    });
  });

  return (state, props) => {
    const params = props.params || {};
    const {
      id,
    } = params;

    const accountId = state.accountId || '-';
    const groupId = state.groupId || '-';
    const merchantName = state.merchantName || '-';
    const merchantEmail = state.merchantEmail || '-';
    const bankId = state.bankId || '-';
    const fiatCode = state.fiatCode || '-';
    const amount = state.amount || '-';
    const description = state.description || '-';
    const status = state.status || '-';
    const tx = (state.tx || {}).id || '-';
    const createdAt = state.createdAt || '';
    const date = formatTime(createdAt, '{dd} {mmm}, {yyyy}');
    const time = formatTime(createdAt, '{hh}:{MM}:{ss} {TT}');

    return (
      <LayoutB>
        <HeaderA>
          <CaptionA
            className="fx1 wmin0"
            description={id}
          >
            Verto payout info
          </CaptionA>
          <ButtonBack
            component={Link}
            href={links.LINK_ADMIN_PAYOUT}
          />
        </HeaderA>
        <WrapperWithLoading
          className="mt30"
          loading={state.loading}
        >
          <div className="mh-10 (lt|w1/2|ph10|mb20)>1">
            <Field label="Payout ID">
              <Tooltip title={id}>{toEllipsisMiddle(id, 16)}</Tooltip>
            </Field>
            <Field label="Account ID">
              <Tooltip title={accountId}>{toEllipsisMiddle(accountId, 16)}</Tooltip>
            </Field>
            <Field label="Bank ID">
              <Tooltip title={bankId}>{toEllipsisMiddle(bankId, 16)}</Tooltip>
            </Field>
            <Field label="Group ID">
              <Tooltip title={groupId}>{toEllipsisMiddle(groupId, 16)}</Tooltip>
            </Field>
            <Field label="Amount">
              <Tooltip title={amount}>{amount} {fiatCode}</Tooltip>
            </Field>
            <Field label="Status">
              <Tooltip title={status}>{status}</Tooltip>
            </Field>
            <Field label="Merchant name">
              <Tooltip title={merchantName}>{merchantName}</Tooltip>
            </Field>
            <Field label="Merchant email">
              <Tooltip title={merchantEmail}>{merchantEmail}</Tooltip>
            </Field>
            <Field label="Datetime">
              <Tooltip title={`${date} ${time}`}>
                <span>{date}</span>
                <span className="c717275"> {time}</span>
              </Tooltip>
            </Field>
            <Field label="Tx">
              <Tooltip title={tx}>{tx}</Tooltip>
            </Field>
            <Field label="Description">
              <Tooltip title={description}>{description}</Tooltip>
            </Field>
          </div>
        </WrapperWithLoading>
      </LayoutB>
    );
  };
});
